import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import http from './http'
import { TApi, TRoles } from './const'
import { leseKursstand, loescheKursstand } from './courseProgress'

/**
 * Den Stand aus dem öffentlichen Kurs ins Konto holen.
 *
 * Die Lernstrecke steht unter `/skills4retail` auch ohne Anmeldung offen; der
 * Stand liegt so lange im Browser. Wer sich danach anmeldet, soll ihn nicht
 * noch einmal erarbeiten müssen — genau das verspricht die Einladung auf der
 * Kursseite.
 *
 * **Gleich nach der Anmeldung, nicht erst auf der Konzeptseite.** Wer sich
 * anmeldet und die Lernstrecke danach gar nicht öffnet, hätte den Stand sonst
 * bis auf Weiteres nur im Browser — und beim nächsten Aufräumen verloren.
 *
 * **Nur Schüler:innen.** Nur für sie führt die Anwendung überhaupt einen
 * Lernstand; bei allen anderen Rollen bleibt der Stand im Browser liegen, wo er
 * niemandem schadet und einer späteren Anmeldung als Schüler:in noch zugute
 * kommt.
 *
 * Der Aufruf ist harmlos, wenn er zweimal ankommt: Der Server behält je Kapitel
 * das bessere Ergebnis. Gelöscht wird hier trotzdem erst nach der Bestätigung —
 * schlägt der Aufruf fehl, bleibt der Stand liegen und es wird beim nächsten
 * Anmelden erneut versucht.
 */
export default function useCourseProgressImport() {
	const isAuth = useSelector(state => state.user.isAuth)
	const role = useSelector(state => state.user.role)

	// Ein Versuch je Sitzung. Ohne die Sperre liefe er bei jedem Rendern erneut,
	// solange die Antwort unterwegs ist.
	const laeuft = useRef(false)

	useEffect(() => {
		if (!isAuth || role !== TRoles.STUDENT || laeuft.current) return

		const stand = leseKursstand()
		if (!stand.length) return

		laeuft.current = true
		http.post(TApi.STUDENT_CONCEPT_QUIZ_IMPORT, { results: stand }, { disableToast: true })
			.then(({ data }) => {
				loescheKursstand()
				if (data?.imported) {
					toast.success(
						data.imported === 1
							? 'Dein Kapitel aus dem offenen Kurs wurde übernommen.'
							: `Deine ${data.imported} Kapitel aus dem offenen Kurs wurden übernommen.`
					)
				}
			})
			.catch(() => {
				// Kein Hinweis: Wer sich gerade angemeldet hat, kann daran nichts
				// ändern. Der Stand bleibt liegen, der nächste Versuch kommt.
				laeuft.current = false
			})
	}, [isAuth, role])
}
